module.exports = __webpack_public_path__ + "static/media/next.3a10b070.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/next.svg
// module id = 333
// module chunks = 0